import type { SecurityEvent } from '@guard-dog/contracts';

function stringFact(value: unknown): string | undefined {
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

/** Tenant-scoped facts that let an operator review a non-allow decision without exposing payloads. */
export function EventReviewDetails({ event }: { event: SecurityEvent }) {
  const method = stringFact(event.context?.httpMethod)?.toUpperCase();
  const path = stringFact(event.context?.path);
  const rule = stringFact(event.context?.ruleId);
  const action = stringFact(event.context?.action);
  const mode = stringFact(event.context?.mode);
  const userAgent = stringFact(event.indicators?.userAgent);
  const request = [method, path].filter(Boolean).join(' ');

  if (!request && !rule && !action && !mode && !userAgent) return <span className="muted">—</span>;

  return (
    <div className="event-review">
      {request && <code>{request}</code>}
      {(rule || action || mode) && (
        <span className="muted">
          {[rule && `rule ${rule}`, action, mode].filter(Boolean).join(' · ')}
        </span>
      )}
      {userAgent && (
        <span className="muted" title={userAgent}>
          {userAgent}
        </span>
      )}
    </div>
  );
}
